import { render, staticRenderFns } from "./OrderDeleteList.vue?vue&type=template&id=6605d401&lang=pug"
import script from "./OrderDeleteList.vue?vue&type=script&lang=js"
export * from "./OrderDeleteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports